import React from "react";
import Modal from "react-bootstrap/Modal";
import { IMG_LOGO_1, SIDEBAR_LOGIN_LOGO } from "utils/constant";
import { FORMAT_TEXT_VALUE } from "helpers/common";
export default ({
  showCTradeModal,
  handleCTradeClose,
  currentCloseTradeValue,
}) => {
  return (
    <>
      <Modal
        show={showCTradeModal}
        onHide={handleCTradeClose}
        backdrop="static"
        keyboard={false}
        className="axis_modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="axis_bank m-auto">
            <img
              src={
                currentCloseTradeValue?.imgUrl
                  ? currentCloseTradeValue?.imgUrl
                  : SIDEBAR_LOGIN_LOGO
              }
              alt=""
              className="img-fluid"
            />
          </div>
          {/* <h2 className="text-center my-2">Axis Bank ltd.</h2> */}
          <div className="axix_modal_content my-3">
            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Balance</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    $
                    {currentCloseTradeValue?.userDetails?.walletCredit
                      ? (currentCloseTradeValue.userDetails?.walletCredit).toFixed(
                          2
                        )
                      : "0"}
                  </label>
                </li>
              </ul>

              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Qty</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    {currentCloseTradeValue?.qty}
                  </label>
                </li>
              </ul>
            </div>
            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Client Name</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">{`${currentCloseTradeValue?.userDetails?.first_name} ${currentCloseTradeValue?.userDetails?.last_name}`}</label>
                </li>
              </ul>
            </div>

            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Name</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    {currentCloseTradeValue?.name}
                  </label>
                </li>
              </ul>
            </div>
            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Commission</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    $
                    {currentCloseTradeValue?.commission
                      ? (currentCloseTradeValue?.commission).toFixed(2)
                      : "0"}
                  </label>
                </li>
              </ul>
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Type</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    {currentCloseTradeValue?.type
                      ? currentCloseTradeValue?.type
                      : "N/A"}
                  </label>
                </li>
              </ul>
            </div>

            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Account ID</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    {currentCloseTradeValue?.userDetails?.accountData
                      ?.account_number
                      ? currentCloseTradeValue?.userDetails?.accountData
                          ?.account_number
                      : "N/A"}
                  </label>
                </li>
              </ul>
            </div>

            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Symbol</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    {currentCloseTradeValue?.symbol
                      ? currentCloseTradeValue?.symbol
                      : "N/A"}
                  </label>
                </li>
              </ul>

              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Amount</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    $
                    {currentCloseTradeValue?.price
                      ? (currentCloseTradeValue?.price).toFixed(2)
                      : "0"}
                  </label>
                </li>
              </ul>
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Status</strong>
                  </label>
                </li>
                <li>
                  {/* <label className="col-form-label">
                    {currentCloseTradeValue?.status
                      ? currentCloseTradeValue?.status
                      : "N/A"}
                  </label> */}
                  <label className="badge badge-success payment_status">
                    {currentCloseTradeValue?.status
                      ? FORMAT_TEXT_VALUE(currentCloseTradeValue?.status)
                      : "N/A"}
                  </label>
                </li>
              </ul>
            </div>

            <div className="line_up d-flex align-items-center gap-3 justify-content-center">
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Bought Price</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    $
                    {currentCloseTradeValue?.boughtPrice
                      ? (currentCloseTradeValue?.boughtPrice).toFixed(2)
                      : "0"}
                  </label>
                </li>
              </ul>

              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Current Price</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    $
                    {currentCloseTradeValue?.current_price
                      ? (currentCloseTradeValue?.current_price).toFixed(2)
                      : "0"}
                  </label>
                </li>
              </ul>
              <ul className="d-flex align-items-center gap-3 justify-content-center">
                <li>
                  <label className="col-form-label">
                    <strong>Equity</strong>
                  </label>
                </li>
                <li>
                  <label className="col-form-label">
                    $
                    {currentCloseTradeValue?.userDetails?.equity
                      ? (currentCloseTradeValue?.userDetails?.equity).toFixed(2)
                      : "0"}
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
